var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pullNewBanner"},[_c('p',{staticClass:"countDown"},[_vm._v(" 活动倒计时： "),_c('span',[_vm._v(_vm._s(_vm.time.d))]),_vm._v("天 "),_c('span',[_vm._v(_vm._s(_vm.time.h))]),_vm._v(": "),_c('span',[_vm._v(_vm._s(_vm.time.m))]),_vm._v(": "),_c('span',[_vm._v(_vm._s(_vm.time.s))])]),_c('img',{attrs:{"src":_vm.activityPicture,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }